import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { passthroughSearch } from '@/router/search';
import RfidTags from '@/ui/pages/RfidTags/RfidTags';

export const Route = createFileRoute('/_dashboard/rfid-tags/')({
  validateSearch: passthroughSearch,
  beforeLoad: requireRoute('/rfid-tags'),
  component: RfidTags,
});
